import { Header, Text } from '@rbilabs/universal-components';

export const Heading = Header.withConfig({
  color: Styles.color.grey.one,
  textTransform: Styles.textTransform.headlines,
  variant: 'headerTwo',
  fontFamily: 'heading',
  textAlign: 'center',
  fontSize: '2xl',
});

export const CenteredText = Text.withConfig({
  textAlign: 'center',
  fontSize: 'md',
  color: Styles.color.grey.one,
  padding: '$4',
});
